import { Navbar, Footer } from './LandingPage';
import { WanderfulHero } from './WanderfulHero';
import { FileText, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RubricTemplatesPage = () => {
  const navigate = useNavigate();

  const templates = [
    {
      title: "UPSC GS Mains Rubric",
      description: "Standardized marking scheme for General Studies papers (GS1-GS4) including content, structure, and language parameters.",
      type: "PDF + DOCX",
      tags: ["UPSC", "Mains", "Official Standards"]
    },
    {
      title: "JEE Advanced Step-Marking Guide",
      description: "Detailed rubric for awarded partial marks in Physics and Chemistry problems based on methodology.",
      type: "PDF",
      tags: ["JEE", "IIT", "Partial Marking"]
    },
    {
      title: "CBSE Class 12 Board Pattern",
      description: "The latest evaluation guidelines for CBSE Board English and Humanities subjects.",
      type: "PDF",
      tags: ["CBSE", "Board Exams", "2026 Pattern"]
    },
    {
      title: "CA Inter/Final Evaluation Schema",
      description: "Keyword-based marking rubric for professional accounting and law papers.",
      type: "PDF",
      tags: ["CA", "Professional", "Keywords"]
    }
  ];

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <WanderfulHero 
        title="Free Industry-Standard Rubric Templates."
        subtitle="Standardize your marking process with our free library of evaluation rubrics used by top institutes."
        cta1Text="Download All"
      />

      <section className="py-8 sm:py-12 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-12 lg:gap-16 items-start">

            {/* Templates Grid */}
            <div className="lg:col-span-12">
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                 {templates.map((temp, index) => (
                   <div key={index} className="bg-[#f9f9f9] rounded-2xl sm:rounded-3xl p-4 sm:p-6 border border-transparent hover:border-gray-200 transition-all duration-300 group">
                     <div className="flex items-center justify-between mb-6">
                        <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-sm">
                           <FileText className="w-6 h-6 text-black" />
                        </div>
                        <span className="text-[10px] font-bold text-gray-400 bg-white px-2 py-1 rounded-md border border-gray-100 uppercase tracking-widest">
                          {temp.type}
                        </span>
                     </div>
                     <h3 className="text-lg font-bold text-black mb-3">{temp.title}</h3>
                     <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                       {temp.description}
                     </p>
                     <div className="flex flex-wrap gap-2">
                        {temp.tags.map((tag, i) => (
                          <span key={i} className="text-[10px] font-bold text-gray-500 uppercase">#{tag}</span>
                        ))}
                     </div>
                   </div>
                 ))}
               </div>

               <div className="mt-8 sm:mt-12 p-4 sm:p-6 md:p-8 bg-gray-50 rounded-2xl sm:rounded-3xl border border-dashed border-gray-300">
                  <h4 className="font-bold text-black mb-4">Need a Custom Rubric?</h4>
                  <p className="text-gray-500 text-sm mb-6">
                    Our team can help you digitize your proprietary marking schemes and integrate them with Parakh AI for 100% automated evaluation.
                  </p>
                  <button onClick={() => navigate('/support')} className="text-black font-bold flex items-center gap-2 group text-sm uppercase tracking-wider hover:opacity-70 transition-opacity">
                    Talk to an Expert <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
               </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RubricTemplatesPage;
